import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const JobsInGurugram = () => {
  return (
    <>
      <Navbar />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Jobs in Gurugram – Latest Job Openings {new Date().getFullYear()}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>jobs in Gurugram</strong>? Explore
          thousands of opportunities in IT, Marketing, Finance, Education,
          Healthcare, and more. Whether you’re a fresher or an experienced
          professional, find your dream job in Gurugram today.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>HCL</li>
          <li>Accenture</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Job Categories Available
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Development Jobs in Gurugram</li>
          <li>Marketing Jobs in Gurugram</li>
          <li>Finance Jobs in Gurugram</li>
          <li>Sales Jobs in Gurugram</li>
          <li>Full-time Jobs in Gurugram</li>
          <li>Web Development Jobs in Gurugram</li>
          <li>Digital Marketing Jobs in Gurugram</li>
          <li>Telecalling Jobs in Gurugram</li>
          <li>IT Jobs in Gurugram</li>
          <li>Technical Support Jobs in Gurugram</li>
          <li>App Development Jobs in Gurugram</li>
          <li>HR Jobs in Gurugram</li>
          <li>Fresher Jobs in Gurugram</li>
          <li>Frontend Developer Jobs in Gurugram</li>
          <li>Backend Developer Jobs in Gurugram</li>
          <li>Full Stack Developer Jobs in Gurugram</li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> – your
          trusted platform to find verified job openings in Gurugram . No
          registration required – apply directly!
        </p>
      </div>
      <Footer />
    </>
  );
};

export default JobsInGurugram;
